import IndexModel from "@/service/v1/sigap/IndexModel";
 
class PatrimonioService extends IndexModel { 
       
    constructor() {
        super();
        this.url =  this.url + '/Patrimonio' ;  
    }
 
    public getApiUrl(  ) { 
        return this.getAxios().defaults.baseURL + this.url; 
    }
 
    public getModel( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id    )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
  
    public getTodos(search) : Promise<any> {  
        if(search){
            return  new Promise((resolve, reject) => {
                this.getAxios().get( this.url + '?search=' + search    )
                .then(response => {    
                    resolve( response.data);  
                })
                .catch(error => {  
                    reject(error.response);
                }) 
            }); 
        } 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
 
    
    public ProccesaPatrimonioSigaLote(   dados: any ) : Promise<any> {  
        const head = { 'Authorization': this.getAxios().defaults.headers.common["Authorization"] }; 
        head["Content-Type"] = "multipart/form-data";  
        return  new Promise((resolve, reject) => {  
            this.getAxios().post( this.url + '/PatrimonioSigaLote'   , dados , { headers: head }   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
 
    public ProccesaPatrimonioSGPMLote(   dados: any ) : Promise<any> {  
        const head = { 'Authorization': this.getAxios().defaults.headers.common["Authorization"] }; 
        head["Content-Type"] = "multipart/form-data";  
        return  new Promise((resolve, reject) => {  
            this.getAxios().post( this.url + '/PatrimonioSGPMLote'   , dados , { headers: head }   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }

    
    public excluirTudo( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().delete( this.url  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
 


}
 

export default PatrimonioService;

